// extracted by mini-css-extract-plugin
module.exports = {"primary":"styles_primary__2QaAY","secondary":"styles_secondary__yAKQT","children":"styles_children__1dvhF","tertiary":"styles_tertiary__30q9O"};